import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// const home = (resolve) => {
//   import('@/page/home').then((module) => {
//     resolve(module)
//   })
// }

// const orderDetail = (resolve) => {
//   import('@/page/orderDetail').then((module) => {
//     resolve(module)
//   })
// }

const delAccount = (resolve) => {
  import('@/page/delAccount/').then((module) => {
    resolve(module)
  })
}

const chooseReson = (resolve) => {
  import('@/page/delAccount/chooseReson.vue').then((module) => {
    resolve(module)
  })
}

const cancelPage = (resolve) => {
  import('@/page/delAccount/cancel.vue').then((module) => {
    resolve(module)
  })
}

const delsuccess = (resolve) => {
  import('@/page/delAccount/delsuccess.vue').then((module) => {
    resolve(module)
  })
}




export default new Router({
  routes: [
    //home
    {
      path: '/',
      name: 'delAccount',
      component: delAccount,
    },

    // {
    //   path: '/orderDetail',
    //   name: 'orderDetail',
    //   component: orderDetail,
    // },
    // {
    //   path: '/delAccount',
    //   name: 'delAccount',
    //   component: delAccount,
    // },
    {
      path: '/chooseReson',
      name: 'chooseReson',
      component: chooseReson,
    },
    {
      path: '/cancelPage',
      name: 'cancelPage',
      component: cancelPage,
    },
    {
      path: '/delsuccess',
      name: 'delsuccess',
      component: delsuccess,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js